import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult } from './types';

const campaignsApi = {
  getAll(params?: cyrian.api.campaigns.GetParams): ApiResponse<WrappedResult<cyrian.api.campaigns.Campaign[]>> {
    return request({
      method: 'get',
      url: '/campaigns',
      params,
    });
  },
  create(data: cyrian.api.campaigns.CampaignParams): ApiResponse<WrappedResult<cyrian.api.campaigns.Campaign>> {
    return request({
      method: 'post',
      url: '/campaigns',
      data,
    });
  },
  update(
    id: number,
    data: cyrian.api.campaigns.CampaignParams,
  ): ApiResponse<WrappedResult<cyrian.api.campaigns.Campaign>> {
    return request({
      method: 'patch',
      url: `/campaigns/${id}`,
      data,
    });
  },
  delete(id: number): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'delete',
      url: `/campaigns/${id}`,
    });
  },
};

export default campaignsApi;
